import { useState } from 'react';
import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENTS_IMPORTER = gql`
  query getDocumentImporterTemplates($companyId: String!, $queryOptions: QueryOptionsInput) {
    getDocumentsImporter(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        title
        companyId
        createdAt
        createdBy
        totalImportedDocuments
      }
      totalCount
    }
  }
`;

export const useGetDocumentsImporter = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'title', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_DOCUMENTS_IMPORTER, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const documentsImporter = data?.getDocumentsImporter || {};

  return {
    collection: documentsImporter?.collection || [],
    loading,
    paginationConfig: {
      total: documentsImporter?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'title', sortBy }]);
      }
    },
  };
};
